import {useEffect, useState} from "react";

export function useSSE(endpoint, topics, defaultValue = null, reconnectSec = 5) {
    const [value, setValue] = useState(defaultValue)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(true)

    const [online, setOnline] = useState([])

    const customEvent = (e, t) => {
        const data = JSON.parse(e?.data)

        if (t === "online") {
            setOnline(prev => [...prev.filter(i => i.serial !== data.serial), data])
        }

        setValue(prev => ({...prev, [t]: data}))
    }

    useEffect(() => {
        if (endpoint) {
            let eventSource
            let timeout

            function connect() {
                // Create EventSource for SSE endpoint
                setLoading(true)
                eventSource = new EventSource(endpoint)

                eventSource.onopen = () => {
                    console.log("EventSource connected!")
                    setError(null)
                    setValue(defaultValue)
                    setLoading(false)
                }

                // eventSource can have event listeners based on the type of event.
                // By default, for message type of event it has the onmessage method which can be used directly
                // or this same can be achieved through explicit event listeners
                // eventSource.addEventListener("update", event => {
                //     try {
                //         const data = JSON.parse(event?.data)
                //         setValue(data)
                //     } catch (error) {
                //         setError(error.message)
                //         console.error('Parsing error:', error.message);
                //     }
                // })


                topics.forEach(topic => eventSource.addEventListener(topic, event => customEvent(event, topic)))


                //In case of any error, if eventSource is not closed explicitly then client will retry the connection a new call to backend will happen and the cycle will go on.
                eventSource.onerror = error => {
                    if (eventSource.readyState === EventSource.CLOSED) {
                        console.log("Connection closed explicitly")
                    } else {
                        console.warn('EventSource failed', error)
                        setError("SSE closed unexpectedly; reconnect in 5 seconds.")
                        eventSource.close()
                        // Automatically reconnect if connection went down
                        timeout = setTimeout(connect, reconnectSec * 1000)
                    }
                    setLoading(false)
                }
            }

            // Trigger connection
            connect()

            // Cleanup when the component unmounts
            return () => {
                console.log("EventSource disconnected!")
                clearTimeout(timeout)
                timeout = null
                topics.forEach(topic => eventSource.removeEventListener(topic, event => customEvent(event, topic)))
                eventSource?.close()
                eventSource = null
            }
        }
    }, [endpoint])

    const clearError = () => setError(null)

    return [value, loading, error, clearError, setValue, setLoading, online]
}